import { z } from "zod";
import { activityItemSchema } from "./people";
export const activityPageSchema = z.object({
  items: z.array(activityItemSchema),
  total: z.number(),
  page: z.number(),
  hasNext: z.boolean(),
});
export type ActivityPage = z.infer<typeof activityPageSchema>;
export const activityFilterOptionsSchema = z.object({
  resources: z.array(z.object({ id: z.string(), name: z.string(), provider: z.string() })),
  types: z.array(z.string()),
});
export const personProfileSchema = z.object({
  firstName: z.string().nullable(),
  lastName: z.string().nullable(),
  companyId: z.string().nullable(),
  id: z.string(),
  reviewKey: z.string(),
  provider: z.string(),
  name: z.string(),
  login: z.string(),
  avatar: z.string(),
  url: z.string(),
  bio: z.string().nullable(),
  company: z.string().nullable(),
  location: z.string().nullable(),
  website: z.string().nullable(),
  domain: z.string().nullable(),
  publicEmail: z.string().nullable(),
  phoneNumber: z.string().nullable(),
  commitEmails: z.array(z.string()),
  twitterUsername: z.string().nullable(),
  socialAccounts: z.array(z.object({ provider: z.string(), url: z.string() })),
  identities: z.array(
    z.object({
      provider: z.string(),
      url: z.string().nullable(),
      handle: z.string().nullable(),
    }),
  ),
  firstSeenAt: z.string(),
  activity: activityPageSchema,
});
export type PersonProfile = z.infer<typeof personProfileSchema>;
